import axios from 'axios';
import {getBuildNumber,getVersion} from 'react-native-device-info';
import { useAppPersistenceStore } from '../../store/useAppPersistenceStore';
import { useProfileStore } from '../../store/useProfileStore';
import { handleRetry } from '../../utils/handleRetry';
import { getWorkflowURI } from '../paths';
import { Platform } from 'react-native';
import {webBuildNumber} from "@ninjacart/nc-nk-core";

export const WorkflowClient = axios.create({
  baseURL: getWorkflowURI(),
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'x-build-number': Platform.OS === 'web' ? webBuildNumber : Number(getBuildNumber()),
    'x-platform': Platform.OS,
    'x-version-code': getVersion(),
    Authorization: `Bearer ${useProfileStore.getState().userProfile?.access_token}`,
    'x-language-code': useAppPersistenceStore?.getState()?.appLanguage,
    ...(Platform.OS !== 'web' && { 'Accept-Encoding': 'gzip' }),
  },
});

WorkflowClient.interceptors.request.use(async (config) => {
  // await syncStreamChannels();
  config.headers.Authorization = `Bearer ${useProfileStore.getState().userProfile?.access_token}`;
  config.headers['x-language-code'] = useAppPersistenceStore?.getState()?.appLanguage;

  // WorkflowClient.interceptors.request.eject(interceptor);
  return Promise.resolve(config);
});

WorkflowClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.config;
    return handleRetry(error, config, 'WORKFLOW_CLIENT_API_FAILED', WorkflowClient);
  }
);
